import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articlesList } from '@/mocks/articleMocks';

export default function ArticlesPage() {
  return (
    <>
      <SEOHead
        title="文章资讯"
        description="aigei 文章资讯频道，提供游戏开发教程、音效设计趋势、美术设计灵感等专业内容，助力创作者持续成长。"
        keywords="aigei,游戏开发教程,音效设计,游戏美术,像素艺术,独立游戏"
        canonicalUrl="/articles"
      />

      <main>
        <div className="relative h-[240px] md:h-[300px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Creative%20writing%20and%20learning%20atmosphere%20with%20warm%20lighting%2C%20books%20and%20digital%20devices%2C%20knowledge%20sharing%20concept%2C%20modern%20cozy%20workspace%2C%20inspirational%20design&width=1600&height=500&seq=articles-banner&orientation=landscape"
            alt="文章资讯"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="w-full px-4 md:px-6 pb-8 md:pb-10">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-white">文章资讯</h1>
              <p className="mt-2 text-sm md:text-base text-white/80">行业动态、开发教程、设计灵感，助力您的创作之旅</p>
            </div>
          </div>
        </div>

        <div className="bg-background-50 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-3">
            <Breadcrumb items={[
              { label: '首页', href: '/' },
              { label: '文章资讯' },
            ]} />
          </div>
        </div>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 gap-6">
              {articlesList.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex flex-col sm:flex-row gap-5 bg-background-100 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300 cursor-pointer"
                >
                  <div className="sm:w-64 flex-shrink-0">
                    <div className="aspect-[16/10] sm:h-full overflow-hidden">
                      <img
                        src={article.cover}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="flex-1 p-4 sm:p-5 sm:pl-0 flex flex-col justify-center">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      {article.tags.map((tag, i) => (
                        <span key={i} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                    </div>
                    <h2 className="font-heading text-lg font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-600 line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <div className="flex items-center gap-2">
                        <span>{article.author}</span>
                      </div>
                      <span>{article.date} · {article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}